angular.module('app').controller('GenericImportCtrl', function($mdToast, $mdDialog, Upload, $route) {
    "ngInject";

    var main = this;

    main.uploadFile = function(file) {
        main.selectedFile = file;
    };

    main.save = function() {
        if(!main.selectedFile) {
            var alert = $mdToast.simple().textContent("Please select a file");
            $mdToast.show(alert);
            return;
        }

        main.uploading = true;

        Upload.upload({
            'method': 'POST',
            'url': main.importURL,
            'data': { 'file': main.selectedFile }
        }).then(
            function(response) {
                var alert = $mdToast.simple().textContent(response.data.message);
                $mdToast.show(alert);
                $mdDialog.hide();
                if(main.reload) {
                    $route.reload();
                }
            },
            function(response) {
                main.selectedFile = null;
                main.uploading = false;
            }
        );
    };
});
